var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', _vm._b({
    attrs: {
      "prefix": "회원",
      "placeholder": "본인",
      "outlined": "",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.query['_member'],
      callback: function callback($$v) {
        _vm.$set(_vm.query, '_member', $$v);
      },
      expression: "query['_member']"
    }
  }, 'v-select', {
    items: _vm.items
  }, false));
}
var staticRenderFns = []

export { render, staticRenderFns }